var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 148,
    viewBox: "0 0 240 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.287 70.428s11.019-1.727 10.276 4.799h-10.276v-4.8Z",
    fill: "#F4A28C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m166.826 58.556-3.329 15.65h18.695l-2.549-17.989-12.817 2.339Z",
    fill: "#D4DBE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.071 8.038h-74.163v48.776h74.163V8.038Z",
    fill: "#00274D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.298 40.287h-23.331v2.123h23.331v-2.123Z",
    fill: "#016AD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.693 45.856h-23.331v2.123h23.331v-2.123Z",
    fill: "#FFC248"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.071 52.62h-74.163v9.231h74.163V52.62Z",
    fill: "#EAEDF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.928 35.157h-19.579v2.122h19.579v-2.122Zm23.651 0H180v2.122h19.579v-2.122Z",
    fill: "#016AD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.473 29.25h-17.506v2.122h17.506V29.25Zm22.06 0h-17.506v2.122h17.506V29.25Z",
    fill: "#FFC248"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.865 40.287h-8.775v2.123h8.775v-2.123Zm8.738 5.569h-8.775v2.123h8.775v-2.123Zm-14.355-10.699h-8.776v2.122h8.776v-2.122Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M145.598 25.163s36.23-3.526 28.235 36.695l2.757 9.807-11.309-5.943.906-3.856h-5.989l-14.6-36.703Z",
    fill: "#000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M145.598 13.83c.57 0 1.032-.448 1.032-1 0-.553-.462-1-1.032-1-.571 0-1.033.447-1.033 1 0 .552.462 1 1.033 1Z",
    fill: "#016AD4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.495 13.83c.571 0 1.033-.448 1.033-1 0-.553-.462-1-1.033-1-.57 0-1.032.447-1.032 1 0 .552.462 1 1.032 1Z",
    fill: "#FFC248"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.248 19.018h-8.776v2.122h8.776v-2.122Zm5.617 5.31h-8.775v2.122h8.775v-2.122Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.473 24.328h-17.506v2.122h17.506v-2.122Zm22.06 0h-17.506v2.122h17.506v-2.122Z",
    fill: "#FFC248"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.865 29.25h-8.775v2.122h8.775V29.25Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.833 19.018h-18.078v2.122h18.078v-2.122Zm16.614 0h-12.832v2.122h12.832v-2.122Z",
    fill: "#016AD4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.833 59.577c1.522 0 2.756-1.195 2.756-2.67 0-1.473-1.234-2.668-2.756-2.668-1.523 0-2.757 1.195-2.757 2.669s1.234 2.67 2.757 2.67Z",
    fill: "#000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.916 71.687H31.638v2.518h37.278v-2.518Z",
    fill: "#D4DBE0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 70.428S35.48 68.7 36.222 75.227h10.276v-4.8Z",
    fill: "#F4A28C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m66.992 58.556-3.329 15.65h18.695l-2.549-17.989-12.817 2.339Z",
    fill: "#D4DBE0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.131 8.038H32.969v48.776h74.162V8.038Z",
    fill: "#00274D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.358 40.287H59.027v2.123h23.33v-2.123Z",
    fill: "#016AD4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.131 52.62H32.969v9.231h74.162V52.62Z",
    fill: "#EAEDF0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.988 35.157H53.41v2.122h19.58v-2.122Z",
    fill: "#016AD4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.532 29.25H59.028v2.122h17.505V29.25Z",
    fill: "#FFC248"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.925 40.287H46.15v2.123h8.775v-2.123Zm8.738 5.569h-8.775v2.123h8.775v-2.123ZM49.308 35.157h-8.776v2.122h8.776v-2.122ZM39.589 13.83c.57 0 1.033-.448 1.033-1 0-.553-.463-1-1.033-1-.57 0-1.033.447-1.033 1 0 .552.462 1 1.033 1Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.658 13.83c.57 0 1.032-.448 1.032-1 0-.553-.462-1-1.032-1-.57 0-1.033.447-1.033 1 0 .552.462 1 1.033 1Z",
    fill: "#016AD4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.556 13.83c.57 0 1.032-.448 1.032-1 0-.553-.462-1-1.032-1-.57 0-1.033.447-1.033 1 0 .552.462 1 1.032 1Z",
    fill: "#FFC248"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.308 19.018h-8.776v2.122h8.776v-2.122Zm5.617 5.31H46.15v2.122h8.775v-2.122Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.532 24.328H59.028v2.122h17.505v-2.122Z",
    fill: "#FFC248"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.925 29.25H46.15v2.122h8.775V29.25Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.893 19.018H52.815v2.122h18.078v-2.122Z",
    fill: "#016AD4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120 148c66.274 0 120-6.743 120-15.06s-53.726-15.059-120-15.059S0 124.623 0 132.94 53.726 148 120 148Z",
    fill: "#00274D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.84 23.558s-25.865 1.72-27.849 15.628c-1.1 7.728 1.085 14.715 3.247 19.428a4.898 4.898 0 0 1-.212 4.51 5.101 5.101 0 0 1-1.62 1.71 5.324 5.324 0 0 1-2.24.824L46.5 69.255v6.008l37.107-1.065c3.765-.107 7.357-1.55 10.097-4.052 2.739-2.503 4.434-5.892 4.764-9.525l3.373-37.063Zm34.068 0s25.865 1.72 27.849 15.628c1.1 7.728-1.085 14.715-3.247 19.428a4.903 4.903 0 0 0 .212 4.51 5.11 5.11 0 0 0 1.621 1.71 5.3 5.3 0 0 0 2.239.824l26.668 3.597v6.008l-37.115-1.1c-3.764-.11-7.356-1.552-10.095-4.055-2.739-2.502-4.434-5.89-4.766-9.523l-3.366-37.027Z",
    fill: "#016AD4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M101.84 23.558s-25.865 1.72-27.849 15.628c-1.1 7.728 1.085 14.715 3.247 19.428a4.898 4.898 0 0 1-.212 4.51 5.101 5.101 0 0 1-1.62 1.71 5.324 5.324 0 0 1-2.24.824L46.5 69.255v6.008l37.107-1.065c3.765-.107 7.357-1.55 10.097-4.052 2.739-2.503 4.434-5.892 4.764-9.525l3.373-37.063Zm34.068 0s25.865 1.72 27.849 15.628c1.1 7.728-1.085 14.715-3.247 19.428a4.903 4.903 0 0 0 .212 4.51 5.11 5.11 0 0 0 1.621 1.71 5.3 5.3 0 0 0 2.239.824l26.668 3.597v6.008l-37.115-1.1c-3.764-.11-7.356-1.552-10.095-4.055-2.739-2.502-4.434-5.89-4.766-9.523l-3.366-37.027Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M216.78 79.76H21.734v53.187H216.78V79.76Z",
    fill: "#D4DBE0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M216.78 74.205H21.734v13.002H216.78V74.205Z",
    fill: "#EAEDF0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m116.485 23.558 3.158-13.333s.104-6.246 4.243-4.792c4.139 1.453 5.38 8.692 3.151 11.138-2.23 2.446-3.716-.892-3.716-.892v7.375l-6.836.504Z",
    fill: "#F4A28C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.076 74.652s-17.142 3.532-9.979 10.231 3.21 16.118-1.753 18.837c-4.964 2.72-25.524 6.001-18.955 28.947h-23.175l-1.709-12.232-14.861-15.196 6.494-14.657 18.271-24.054 12.379 9.937 6.777-2.26 26.511.447Z",
    fill: "#000"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 22.947s-25.784-2.224-29.15 14.635C79.846 54.44 103.84 86.257 103.84 86.257l33.437-1.259s51.945-70.657-24.914-62.052Zm3.135 97.466s1.486 1.9.513 3.699c-.973 1.798.431 3.324 1.902 2.072 1.471-1.252 2.081-6.476 2.081-6.476l-3.322-1.878-1.174 2.583Z",
    fill: "#016AD4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.839 86.257s-2.229 11.333 2.786 11.873c5.016.54 40.496 2.072 46.44-2.742 5.944-4.813 4.458-11.47-15.789-10.39l-33.437 1.26Z",
    fill: "#00274D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.549 88.215s-15.5 11.728-7.512 20.362c7.988 8.634 19.505 13.671 19.505 13.671l1.672-4.137s-24.149-18.168-1.301-21.766l-12.364-8.13Z",
    fill: "#00274D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M123.388 50.044h-9.117c-9.389 0-17 7.37-17 16.462 0 9.093 7.611 16.463 17 16.463h9.117c9.389 0 17.001-7.37 17.001-16.463 0-9.092-7.612-16.462-17.001-16.462Z",
    fill: "#FFC248"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M122.883 66.506h-8.485v32.976h8.485V66.506Z",
    fill: "#FFC248"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M122.883 66.506h-8.485v32.976h8.485V66.506Z",
    fill: "#000"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.908 95.388H101.84v9.851h34.068v-9.85Z",
    fill: "#FFC248"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m117.459 14.593.052-3.159a5.265 5.265 0 0 0-.38-2.128 5.41 5.41 0 0 0-1.21-1.815 2.037 2.037 0 0 1-.532-.597 1.97 1.97 0 0 1-.193-1.535c.073-.255.199-.494.368-.703 1.709-2.367 3.151-.835 4.874-2.928 1.724-2.094 3.025-2.504 5.038 0 2.014 2.504 3.596-.418 4.748 2.647 1.152 3.066.141 4.598-4.317 4.879-3.789.237-2.615 4.396-6.13 6.584a1.526 1.526 0 0 1-1.554.067 1.463 1.463 0 0 1-.573-.552 1.403 1.403 0 0 1-.191-.76Z",
    fill: "#00274D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.352 105.231h-5.409v22.759h5.409v-22.759Z",
    fill: "#FFC248"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M121.352 105.231h-5.409v22.759h5.409v-22.759Z",
    fill: "#000"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m115.943 127.99-10.462 9.354h27.151l-11.287-9.354h-5.402Z",
    fill: "#FFC248"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.994 91.834h-20.061v33.637h20.061V91.833Z",
    fill: "#000"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M182.229 87.207h-4.703v45.74h4.703v-45.74Zm34.551 0h-4.703v45.74h4.703v-45.74Z",
    fill: "#EAEDF0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M216.788 125.472h-35.02v7.468h35.02v-7.468ZM31.638 87.207h-9.904v45.74h9.904v-45.74Z",
    fill: "#EAEDF0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.874 120.01H31.638v5.462h28.236v-5.462Z",
    fill: "#000"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.17 125.256H31.638v7.684H74.17v-7.684Z",
    fill: "#000"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.507 19.018H74.675v2.122h12.832v-2.122Z",
    fill: "#016AD4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.81 59.577c1.522 0 2.757-1.195 2.757-2.67 0-1.473-1.235-2.668-2.757-2.668-1.523 0-2.757 1.195-2.757 2.669s1.234 2.67 2.757 2.67Z",
    fill: "#000"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M142.529 13.83c.57 0 1.033-.448 1.033-1 0-.553-.463-1-1.033-1-.571 0-1.033.447-1.033 1 0 .552.462 1 1.033 1Z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M44.166 111.865s-6.843-1.813-8.337-7.979c0 0 10.61-2.072 10.908 8.526l-2.571-.547Z",
    fill: "#009D93"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M44.968 111.239s-4.785-7.325-.572-14.167c0 0 8.062 4.957 4.459 14.182l-3.886-.015Z",
    fill: "#009D93"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M46.202 111.239s2.526-7.727 10.165-9.195c0 0 1.426 5.036-4.949 9.217l-5.216-.022Z",
    fill: "#009D93"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m41.238 111.038 1.382 9.195 8.739.036 1.292-9.181-11.413-.05Z",
    fill: "#00274D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M200.359 102.022c1.42 0 2.571-1.114 2.571-2.49 0-1.374-1.151-2.489-2.571-2.489-1.42 0-2.571 1.115-2.571 2.49 0 1.375 1.151 2.489 2.571 2.489Z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M204.349 105.231h-13.991v17.003h13.991v-17.003Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSelected);
export default __webpack_public_path__ + "static/media/NoSelected.ed5ed742fbba8a32224ef7243e76853e.svg";
export { ForwardRef as ReactComponent };